import * as React from 'react'
import { useCallback } from 'react'

import { SOLD_SERVICE_STATUS } from '@sales-center/common'
import {
  openDialogActionCreator as openDialog,
  useCWQDialogContext,
} from '@user/components/SoldServices'
import { useCwqAdminClosedLost } from '@user/components/Opportunities/hooks/useCwqAdminClosedLost'

import Button from '@mui/material/Button'

type Props = {
  opportunityId: number
  soldServiceStatus: SOLD_SERVICE_STATUS
}

export function CancelServicesButton(props: Props) {
  const { opportunityId, soldServiceStatus } = props
  const show = useCwqAdminClosedLost(soldServiceStatus)
  const [, dispatch] = useCWQDialogContext()

  const onClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation()
      dispatch(openDialog('cancelServices'))
    },
    [dispatch],
  )

  if (!show) return null

  return (
    <Button
      variant="outlined"
      color="primary"
      size="small"
      onClick={onClick}
      sx={{ whiteSpace: 'nowrap', flexShrink: 0 }}
      data-test-id={`cancel-services-button-${opportunityId}`}
    >
      Cancel Services
    </Button>
  )
}
